import { Card } from "./models/index.js";
import r from "../managers/braze-instance.js";
import { isArray as D } from "../util/code-utils.js";
import N from "../../shared-lib/logger.js";
import { MUST_BE_CARD_WARNING_SUFFIX as P } from "../common/constants.js";
import _ from "./card-manager-factory.js";
export function logContentCardImpressions(o) {
  if (!r.rr()) return !1;
  if (!D(o)) return N.error("cards must be an array"), !1;
  for (const r of o)
    if (!(r instanceof Card)) return N.error(`Each card in cards ${P}`), !1;
  return _.ea().Wt(o).tt;
}
